import PropTypes from 'prop-types';
import styles from './SkillTagEditor.module.css';
import { useSkillTags } from '../../../hooks/useSkillTags';

const SkillTagEditor = ({ selectedTags, setSelectedTags, tagCategories }) => {
    // プロップタイプの定義
    SkillTagEditor.propTypes = {
        selectedTags: PropTypes.array.isRequired,
        setSelectedTags: PropTypes.func.isRequired,
        tagCategories: PropTypes.object.isRequired,
    };

    const {
        inputValue,
        filteredTags,
        tempSelectedTags,
        isModalOpen,
        setInputValue,
        setFilteredTags,
        toggleTagSP,
        removeTag,
        handleInputChange,
        handleInputKeyDown,
        openModal,
        closeModal,
        handleReset,
        handleComplete
    } = useSkillTags({ selectedTags, setSelectedTags, mode: 'editor' });

    return (
        <div className={styles['tag-selector-container']}>
            {/* 選択されたタグの表示エリア */}
            <div className={styles['selected-tags-display']}>
                <div className={styles['selected-tags-wrapper']}>
                    {selectedTags.map((tag, index) => (
                        <div className={styles['tag-item']} key={index}>
                            <span className={styles['tag-text']}>{tag}</span>
                            <button 
                                type="button"
                                className={styles['tag-delete']} 
                                onClick={() => removeTag(tag)}
                            >
                                ×
                            </button>
                        </div>
                    ))}
                    <button 
                        type="button"
                        className={styles['add-tag-button']} 
                        onClick={openModal}
                    >
                        + スキルを追加
                    </button>
                </div>
            </div>

            {/* モーダル（SP版エンジニア検索と同じUI） */}
            {isModalOpen && (
                <div className={styles['modal']}>
                    <div className={styles['modalOverlay']} onClick={closeModal}/>
                    <div className={styles['modalContent']}>
                        {/* ヘッダー */}
                        <div className={styles['modalHeader']}>
                            <button
                                type="button"
                                className={styles['closeButton']}
                                onClick={closeModal}
                            >
                                ×
                            </button>
                            <button
                                type="button"
                                className={styles['resetButton']}
                                onClick={handleReset}
                            >
                                リセット
                            </button>
                        </div>

                        {/* タグ入力欄 */}
                        <div className={styles['inputContainer']}>
                            <input 
                                type="text" 
                                className={styles['tagInput']}
                                placeholder="タグを入力"
                                value={inputValue}
                                onChange={handleInputChange}
                                onKeyDown={handleInputKeyDown}
                            />
                            
                            {/* 選択済みタグを削除ボタン付きで横並び表示 */}
                            {tempSelectedTags.length > 0 && (
                                <div className={styles['selectedTagsContainer']}>
                                    {tempSelectedTags.map((tag, index) => (
                                        <div key={index} className={styles['selectedTag']}>
                                            <span className={styles['selectedTagText']}>{tag}</span>
                                            <button
                                                type="button"
                                                className={styles['removeTagButton']}
                                                onClick={() => toggleTagSP(tag)}
                                            >
                                                ×
                                            </button>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>

                        {/* タグカテゴリー */}
                        <div className={styles['categoriesContainer']}>
                            {/* フィルタリングされたタグ候補の表示（入力があるとき） */}
                            {inputValue.trim() && filteredTags.length > 0 && (
                                <div className={styles['categoryGroup']}>
                                    <h4 className={styles['categoryTitle']}>検索結果</h4>
                                    <div className={styles['tagsList']}>
                                        {filteredTags.map((tag, tagIndex) => (
                                            <button
                                                key={tagIndex}
                                                type="button"
                                                className={`${styles['tagItem']} ${
                                                    tempSelectedTags.includes(tag) ? styles['selectedTagItem'] : ''
                                                }`}
                                                onClick={() => {
                                                    toggleTagSP(tag);
                                                    setInputValue('');
                                                    setFilteredTags([]);
                                                }}
                                            >
                                                {tag}
                                            </button>
                                        ))}
                                    </div>
                                </div>
                            )}
                            
                            {/* 入力がない場合、またはフィルタリング結果がない場合は通常のカテゴリを表示 */}
                            {(!inputValue.trim() || filteredTags.length === 0) && tagCategories && (
                                <>
                                    {Object.entries(tagCategories).map(([category, tags]) => (
                                        <div key={category} className={styles['categoryGroup']}>
                                            <h4 className={styles['categoryTitle']}>{category}</h4>
                                            <div className={styles['tagsList']}>
                                                {tags.map((tag, tagIndex) => (
                                                    <button
                                                        key={tagIndex}
                                                        type="button"
                                                        className={`${styles['tagItem']} ${
                                                            tempSelectedTags.includes(tag) ? styles['selectedTagItem'] : ''
                                                        }`}
                                                        onClick={() => toggleTagSP(tag)}
                                                    >
                                                        {tag}
                                                    </button>
                                                ))}
                                            </div>
                                        </div>
                                    ))}
                                </>
                            )}
                        </div>

                        {/* 完了ボタン */}
                        <div className={styles['actionButtons']}>
                            <button
                                type="button"
                                className={styles['completeButton']}
                                onClick={handleComplete}
                            >
                                完了
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default SkillTagEditor;
